/*
 * Copyright ish group pty ltd 2021.
 *
 * This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License version 3 as published by the Free Software Foundation.
 *
 *  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details.
 */

import { _toRequestType, FULFILLED } from "../../../../common/actions/ActionUtils";
import { EntityName } from "../../../../model/entities/common";

export const GET_CUSTOM_FIELD_TYPES = _toRequestType("get/customFieldTypes");
export const GET_CUSTOM_FIELD_TYPES_FULFILLED = FULFILLED(GET_CUSTOM_FIELD_TYPES);

export const GET_SALE_CUSTOM_FIELD_TYPES = _toRequestType("get/sale/customFieldTypes");

export const GET_INVOICE_CUSTOM_FIELD_TYPES = _toRequestType("get/abstractInvoice/customFieldTypes");
export const GET_CONTACT_CUSTOM_FIELD_TYPES = _toRequestType("get/contact/customFieldTypes");

export const getCustomFieldTypes = (entity: EntityName) => (entity === "ProductItem"
  ? {
    type: GET_SALE_CUSTOM_FIELD_TYPES,
  }
  : (entity === "AbstractInvoice" ? {
    type: GET_INVOICE_CUSTOM_FIELD_TYPES,
  } : (entity === "Contact" ? {
    type: GET_CONTACT_CUSTOM_FIELD_TYPES,
  } : {
    type: GET_CUSTOM_FIELD_TYPES,
    payload: entity
  })));
